// extracted by mini-css-extract-plugin
export default {"container":"logo_container__x1LAD","logoImage":"logo_logoImage__YJt2-"};